// extracted by mini-css-extract-plugin
module.exports = {"comment-module":"comment-module_comment-module__3gVMj","release-box":"comment-module_release-box__2g2YX","reply-box":"comment-module_reply-box__1qP6p"};